import { Target } from '../target/target.model';

export class TargetSummaryDto {
    target: Target;
    sumActivity: number;
    sumTarget: number;
    percent: number;
}
